<template>
  <div>
    <el-radio-group v-if="platform.isMiniGame" v-model="pageType">
      <el-radio-button ghost :label="PAGE_TYPES.WECHAT_MINI_GAME">微信小游戏</el-radio-button>
    </el-radio-group>

    <template v-else>
      <el-radio-group v-model="pageType">
        <el-radio-button ghost :label="PAGE_TYPES.OFFICIAL">官方落地页</el-radio-button>
        <el-radio-button ghost :label="PAGE_TYPES.IOS_APP" v-if="platform.isIOS">App Store下载页</el-radio-button>
        <el-radio-button ghost :label="PAGE_TYPES.XJ_QUICK" disabled> 蹊径性能版落地页（即将下线）</el-radio-button>
      </el-radio-group>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { PLATFORM } from '@/views/create/gdt/model/project-const.js'
import { PAGE_TYPES } from '@/views/create/gdt/model/creative-const.js'
// eslint-disable-next-line
const props = defineProps({
  platform: Number,
  value: {
    type: String,
    default: ''
  }
})
// eslint-disable-next-line
const emits = defineEmits(['input'])

const platform = computed(() => {
  return {
    isIOS: props.platform === PLATFORM.IOS,
    isAndroid: props.platform === PLATFORM.ANDROID,
    isMiniGame: props.platform === PLATFORM.MINIGAME
  }
})

const pageType = computed({
  get() {
    return props.value
  },
  set(val) {
    emits('input', val)
  }
})
</script>

<style lang="scss" scoped></style>
